var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkCopyGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.116,
    height: 23.116,
    viewBox: "0 0 23.116 23.116",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_u30B0_u30EB_u30FC_u30D7_15441",
    "data-name": "\\\\\\\\u30B0\\\\\\\\u30EB\\\\\\\\u30FC\\\\\\\\u30D7 15441",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "copy_1_",
    "data-name": "copy (1)",
    transform: "translate(0.816 0.742)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_u30D1_u30B9_20963",
    "data-name": "\\\\\\\\u30D1\\\\\\\\u30B9 20963",
    d: "M0,0H22V22H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_u30D1_u30B9_20964",
    "data-name": "\\\\\\\\u30D1\\\\\\\\u30B9 20964",
    d: "M16.832,2h-11A1.833,1.833,0,0,0,4,3.833V16.665H5.833V3.833h11Zm2.749,3.666H9.5A1.833,1.833,0,0,0,7.666,7.5V20.331A1.833,1.833,0,0,0,9.5,22.165H19.582a1.833,1.833,0,0,0,1.833-1.833V7.5a1.833,1.833,0,0,0-1.833-1.833Zm0,14.665H9.5V7.5H19.582Z",
    transform: "translate(-2.167 -1.083)",
    fill: "#393939"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "_u9577_u65B9_u5F62_9415",
    "data-name": "\\\\\\\\u9577\\\\\\\\u65B9\\\\\\\\u5F62 9415",
    width: 23.116,
    height: 23.116,
    transform: "translate(0.001 0)",
    fill: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkCopyGray);
export default __webpack_public_path__ + "static/media/linkCopyGray.eca381b00321f144206eff60c60ed4ab.svg";
export { ForwardRef as ReactComponent };